import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";
import { useAuthStore } from "../stores/authStore";
import type { LoginRequest } from "../types/auth.types";

export const useLogin = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);

  return useMutation({
    mutationFn: (credentials: Omit<LoginRequest, "ServiceCategory">) =>
      login({ ...credentials, ServiceCategory: "ADMIN" }),
    onSuccess: (data) => {
      setUser(data.result);
      navigate("/companies");
    },
    onError: (error: Error) => {
      console.error("로그인 실패:", error.message);
    },
  });
};
